import { env } from 'process'
import {
  CheckboxField,
  DateField,
  ImageField,
  InputField,
  SelectField,
  TextareaField,
  TimeField,
} from 'components/Inputs/Inputs'
import flatpickr from 'flatpickr'
import { useCallback, useEffect, useRef, useState } from 'react'
import { Field, Form } from 'react-final-form'
import { useTranslation } from 'react-i18next'
import axios from 'axios'
import {
  useGetHotelByIdQuery,
  useGetHotelGeneralConfigrationQuery,
} from 'redux/store/hotels/HotelsApi'
import { useToast } from '@chakra-ui/react'
import { FieldArray } from 'react-final-form-arrays'
import arrayMutators from 'final-form-arrays'
import { useNavigate, useParams } from 'react-router-dom'
import { useGetConfigurationQuery } from 'redux/store/actions'
import { skipToken } from '@reduxjs/toolkit/dist/query'
import Loading from 'components/Loading/Loading'
import {
  useAddTransportationMutation,
  useEditTransportationMutation,
  useGetTransportationByIdQuery,
} from 'redux/store/transportations/TransportationsAPI'

interface CheckboxState {
  id: string
  label: string
  name: string
  checked: boolean
}

interface ImageType {
  src: string
  alt: string
  sendSrc?: File
}

interface GeneralProps {
  setContent: React.Dispatch<React.SetStateAction<string>>
  setId: React.Dispatch<React.SetStateAction<number | null>>
  mode: string
}

export default function TransportationGeneral({
  setContent,
  setId,
  mode,
}: GeneralProps): JSX.Element {
  const [inActive, setInActive] = useState(false)
  const { t } = useTranslation()
  const toast = useToast()
  const { data: configrations } = useGetHotelGeneralConfigrationQuery({})
  const params = useParams()
  const [country, setCountry] = useState<string | number>()
  const [isLoading, setIsLoading] = useState(false)
  const { data: Cities } = useGetConfigurationQuery(
    country ? `api/Configurations/countries/${country}/cities` : skipToken
  )
  const [editTransportation] = useEditTransportationMutation()
  const { data: transportation } = useGetTransportationByIdQuery(
    params.id ? Number(params.id) : skipToken
  )
  const navigate = useNavigate()
  useEffect(() => {
    if (mode && transportation?.data?.Company) {
      setCountry(transportation.data.Company.CountryId)
    }
  }, [])
  const [addTransportaion] = useAddTransportationMutation()
  const onSubmit = async (values: any): Promise<void> => {
    if (mode === 'edit') {
      editTransportation({ body: values, id: params.id })
        .then((res: any) => {
          toast({
            title: 'Transportaion edited successfully',
            status: 'success',
            duration: 1500,
            isClosable: true,
          })
          setContent('Vehicles')
        })
        .catch((err: any) => {
          toast({
            title: err.message,
            status: 'error',
            duration: 1500,
            isClosable: true,
          })
        })
    } else {
      addTransportaion(values)
        .then((res: any) => {
          toast({
            title: 'Transportaion created successfully',
            status: 'success',
            duration: 1500,
            isClosable: true,
          })
          setId(res?.data?.data?.Id)
          setContent('Vehicles')
        })
        .catch((err: any) => {
          toast({
            title: err.message,
            status: 'error',
            duration: 1500,
            isClosable: true,
          })
        })
    }
  }
  const validate = (values: any): any => {
    const errors: any = {}
    if (!values.Name) {
      errors.Name = t('validation required')
    }
    if (!values.CountryId) {
      errors.CountryId = t('validation required')
    }
    if (!values.CityId) {
      errors.CityId = t('validation required')
    }
    if (!values.Address) {
      errors.Address = t('validation required')
    }
    if (!values.ContactPersonName) {
      errors.ContactPersonName = t('validation required')
    }
    if (!values.ContactPersonEmail) {
      errors.ContactPersonEmail = t('validation required')
    }
    if (!values.ContactPersonPhone) {
      errors.ContactPersonPhone = t('validation required')
    }
    if (!values.Notes) {
      errors.Notes = t('validation required')
    }
    if (!values.CurrencyId) {
      errors.CurrencyId = t('validation required')
    }
    return errors
  }
  return (
    <>
      <div className="hotelsGeneral w-full mt-4  ">
        <div className="hotelsGeneralContent">
          <div className="w-full pt-0 pb-0 mb-[-10px] text-black">
            <Form
              onSubmit={onSubmit}
              validate={validate}
              initialValues={transportation?.data?.Company}
              mutators={{ ...arrayMutators }}
              render={({ handleSubmit, form, submitting, pristine, modifiedSinceLastSubmit }) => {
                return (
                  <form onSubmit={handleSubmit} className="w-full flex flex-wrap">
                    <div className="bg-white w-full flex flex-wrap rounded-xl p-4">
                      <h4 className="text-lg">{t('Transportation Details')}</h4>
                      <div className="w-full">
                        <Field
                          id="inActive"
                          className="ml-0"
                          label="inactive"
                          name="IsInActive"
                          type="checkbox"
                          checked={inActive}
                          onChange={() => setInActive(!inActive)}
                          render={CheckboxField}
                          disabled={mode === 'view'}
                        />
                      </div>
                      <div className="w-1/5 p-1">
                        <Field
                          label="Company Name"
                          disabled={mode === 'view'}
                          name="Name"
                          type="text"
                          render={InputField}
                        />
                      </div>{' '}
                      <div className="w-1/5 p-1">
                        <Field
                          label="Company Name Ar"
                          disabled={mode === 'view'}
                          name="NameAr"
                          type="text"
                          render={InputField}
                        />
                      </div>{' '}
                      <div className="w-1/5 p-1">
                        <Field
                          label="Currency"
                          name="CurrencyId"
                          render={SelectField}
                          options={configrations?.data?.Currencies || []}
                          valueField="Id"
                          textField="Value"
                        />
                      </div>
                      <div className="w-1/5 p-1">
                        <Field
                          label="Country"
                          name="CountryId"
                          render={SelectField}
                          options={configrations?.data?.Countries || []}
                          valueField="Id"
                          onChange={(e: any) => setCountry(e)}
                          disabled={mode === 'view'}
                          textField="Value"
                        />
                      </div>
                      <div className="w-1/5 p-1">
                        <Field
                          label="City"
                          name="CityId"
                          render={SelectField}
                          options={Cities?.data || []}
                          valueField="Id"
                          textField="Value"
                          disabled={mode === 'view'}
                        />
                      </div>
                      <div className="w-2/5 p-1">
                        <Field
                          label="Address"
                          disabled={mode === 'view'}
                          name="Address"
                          type="text"
                          render={InputField}
                        />
                      </div>
                      <div className="w-2/5 p-1">
                        <Field
                          label="Address Ar"
                          disabled={mode === 'view'}
                          name="AddressAr"
                          type="text"
                          render={InputField}
                        />
                      </div>
                      <div className="w-1/5 p-1">
                        <Field
                          label="Contact Person Name"
                          disabled={mode === 'view'}
                          name="ContactPersonName"
                          type="text"
                          render={InputField}
                        />
                      </div>
                      <div className="w-1/5 p-1">
                        <Field
                          label="Contact Person Email"
                          disabled={mode === 'view'}
                          name="ContactPersonEmail"
                          type="email"
                          render={InputField}
                        />
                      </div>
                      <div className="w-1/5 p-1">
                        <Field
                          label="Contact Person Phone No."
                          name="ContactPersonPhone"
                          type="number"
                          disabled={mode === 'view'}
                          render={InputField}
                        />
                      </div>
                      <div className="w-1/5 p-1">
                        <Field
                          label="Notes"
                          name="Notes"
                          type="text"
                          disabled={mode === 'view'}
                          render={InputField}
                        />
                      </div>
                      <div className="w-1/5 p-1">
                        <Field
                          label="Notes Ar"
                          name="NotesAr"
                          type="text"
                          disabled={mode === 'view'}
                          render={InputField}
                        />
                      </div>
                    </div>

                    {mode !== 'view' && (
                      <div className=" mt-3 mb-3  ml-auto rtl:ml-0 rtl:mr-auto flex p-1 mr-0 ">
                        <div>
                          <button
                            className="btn-primary text-sm	 rounded-xl cursor-pointer w-28 "
                            type="submit"
                            disabled={submitting || pristine}>
                            {t('Save')}
                          </button>
                        </div>
                        <div className="px-1">
                          <button
                            className="btn-alternative text-sm	 cursor-pointer"
                            type="button"
                            disabled={submitting || (!modifiedSinceLastSubmit && pristine)}
                            onClick={() => {
                              form.reset()
                            }}>
                            {t('Clear All')}
                          </button>
                        </div>
                      </div>
                    )}
                  </form>
                )
              }}
            />
          </div>
        </div>
      </div>
      {isLoading && <Loading />}
    </>
  )
}
